import React,{ useCallback, useEffect, useMemo } from "react";
import { useState } from "react";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

//config
import defaultConfig from "../../config/Config";

//Utis
import SelectBox from "../../components/admin/SelectBox";
import { ToSelectOption } from "../../Utils/utils/CommanFnc";
import Table from "../../components/admin/Table";

//Action 
import { getAllState } from "../../slices/InitialDataSlice";
import { getUserByType } from "../../slices/UserSlice";
import { getStock } from "../../slices/StockSlice";
import moment from "moment";

export function List() { 
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const qStr = Object.fromEntries([...searchParams.entries()])
    
    // redux state
    const authData = useSelector( (state) => state.auth.authData );
    const allStates = useSelector( (state) => state.initialData.StateList );
    const { usersByType } = useSelector((state) => state.users);
    const {loading, totalCount, list} = useSelector( (state) => state.stock )
    console.log(list)
    //local state
    const [queryString, setQueryString] =   useState(qStr);
    const [assignedState, setAssignedState] = useState([]);
    const [userTypes, setUserTypes] = useState([]);
    const [businessData, setBusinessData] = useState([]);
    const [vendorList, setVendorList] = useState([]);
    //const [selectedUserType, setSelectedUserType] = useState('');

    const [defaultParams, setDefaultParams] = useState({
        pageLength:defaultConfig.defaultLimit,
        page:1
    });

    const columns =  useMemo(()=>{
        let col  = [
          {
            name: 'Vendor Name',
            selector: (row) => row?.users.name,
            sortable:true,
            center:true
          },
          {
            name:"Product",
            selector: (row) => row?.products?.name,
            sortable:true,
            center:true
          },
          {
            name: "Quantity",
            selector: (row) => row.quantity,
            sortable: true,
            center: true,
          },
          {
            name: "Updated At",
            selector: (row) => row?.updatedAt,
            sortable:false,
            center:true,
            cell: (row) => (
                <>
                    {moment(row.updatedAt).format(defaultConfig.dateFormat)}
                </>
            )
          }
        ];
        
        return col
    },[])

    useEffect( () => {
        dispatch(getAllState());
        setUserTypes(
            ToSelectOption(
                  defaultConfig.orderUserType, 
                  { 
                    value:"value", 
                    label:"label" 
                  }
            )
        )
    }, [])

    useEffect( () => {
        const assignedStateIds = authData.user.assignState;
        setAssignedState( () => {
            const states = findAssignedState(allStates, assignedStateIds);
            return  ToSelectOption(
              states,
              {
                value:"_id",
                label: 'name'
              }
            )
        } );
    }, [allStates, authData])

    useEffect (() => { 
    let list = []
    if(typeof usersByType !== "undefined"){
        list = usersByType?.map( ({userDetails, _id: userID}) => {
        return {
            value: userID,
            label: userDetails.shopName
        }
        })
    }
    setVendorList(list)
    },[setVendorList, usersByType]);
    
    useEffect( () => { 
        if(queryString.stateId){
            getVendor({value: queryString.stateId});
        }
        if(queryString.stateId && queryString.userId){
            getStockList({ value: queryString.userId});
        }
        
    }, [queryString.userType, queryString.stateId, queryString.userId])

    useEffect(() => { 
        setBusinessData({list, totalCount})
    }, [list, totalCount]); 

    function findAssignedState(allStates, assignedStateIds) {
        if(!assignedStateIds || (assignedStateIds.length === 0)) {
          return allStates;
        }
        return allStates.filter( (state) => assignedStateIds.indexOf(state._id) > -1 );
    }

    const onUserTypeChange = function ({value}) {
        const data = { userType: value};
        const params = Object.assign(defaultParams, {pageLength: defaultConfig.defaultLimit, page: 1, ...data});
        queryString.userType = value;
        setQueryString({...queryString, ...{userType: value}});
        setSearchParams(params);
    }

    const getVendor = function({value}) {
        const selectedUserType = queryString.userType;
        if(selectedUserType && value) {
            const data = { stateId: value, ...queryString};
            const params = Object.assign(defaultParams, {pageLength: defaultConfig.defaultLimit, page: 1, ...data});
            setSearchParams(params);
            setQueryString({...queryString, ...{stateId: value}});
            dispatch(getUserByType({userType: selectedUserType, stateId: value}));
        }
    }

    const getStockList = function ({value}) {
        const data = { userId: value, ...queryString };
        setQueryString({...queryString, ...{userId: value}});
        let params = Object.assign(defaultParams, {pageLength: defaultConfig.defaultLimit, page: 1, ...data});
        setSearchParams(params);  
        setDefaultParams(params);
        queryString.userId = value;
        const { userType, stateId, userId} = queryString
        if(userType && stateId && userId) {
            dispatch(getStock({data: params}));
        }
    }

    const setPaginationData = (paginationData) =>{
        const params = {...defaultParams, page: paginationData.page, pageLength: paginationData.pageLength}
        setDefaultParams(params)
        setSearchParams(params)
    }
    console.log(businessData)
    return (
        <React.Fragment>
            <div className="revenue-wrapper">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card table-card">
                            <div className="d-sm-flex justify-content-between align-items-center pl-4 pr-4">
                                <h4 className="card-title mB25 mb-sm-0"><i className="fas fa-clock"></i> Stock List</h4>
                            </div>
                            <div className="row m-3">
                                <div className="col-sm-10">
                                    <div className="row">
                                        <div className="col-sm-3 p-0 ml-1">
                                            <SelectBox
                                                placeholder="Select Vendor Type"
                                                options={userTypes}
                                                value={
                                                    userTypes.find( ({value}) => value === queryString.userType )
                                                }
                                                isClearable={true}
                                                onChange={(opt) => onUserTypeChange(opt)}
                                            />
                                        </div>
                                        <div className="col-sm-3 p-0 ml-1">
                                            <SelectBox
                                                placeholder="Select State"
                                                options={assignedState}
                                                value={
                                                    assignedState.find( ({value}) => value === queryString.stateId )
                                                }
                                                isClearable={true}
                                                onChange={(opt) => getVendor(opt)}
                                            />
                                        </div>
                                        <div className="col-sm-3 p-0 ml-1">
                                            <SelectBox
                                                options={vendorList}
                                                isClearable={true}
                                                value={
                                                    vendorList.find( ({value}) => value === queryString.userId )
                                                }
                                                onChange={(opt) => getStockList(opt)}
                                                
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Table 
                            totalCount={businessData.totalCount}
                            data={businessData.list} 
                            columns={columns} 
                            dataLoadFnc={getStock} 
                            extraConfig = {defaultParams}
                            loading={loading}  
                            callBack={setPaginationData}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}